<template>
  <component :is="componentLoader" :ot="ot" :prms="prms"></component>
</template>

<script>
export default {
  name: "taskBox",
  props: {
    ot: {
      type: Number,
      default: () => 0
    },
    prms: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
    if (this.ot > 0) {
      this.loadComponent();
    }
  },
  methods: {
    loadComponent() {
      this.componentLoader().then();
    }
  },
  computed: {
    componentLoader() {
      return () => import(`@/views/modules/task/list/special/${this.ot}.vue`);
    }
  }
};
</script>
